import type { GetInteractor } from '@coris-ts/repository/interactor/get.interactor'
import { GetSectionsComparisonQuery } from '../../data/queries/get-sections-comparison.query'
import { type SectionsComparisonEntity } from '../../data/entities/sections.entity'
import { SectionsComparisonEntityToSectionsComparisonMapper } from '../mappers/sections.mappers'
import { type SectionsComparison, type SectionsQueryParams } from '../models/sections'

export class GetSectionsComparisonInteractor {
  private readonly mapper = new SectionsComparisonEntityToSectionsComparisonMapper()

  constructor(private readonly getSectionsComparison: GetInteractor<SectionsComparisonEntity>) {}

  // The comparison endpoint ignores the previous-period dates, so they are not part of its params
  public async execute(params: Omit<SectionsQueryParams, 'fromPrevious' | 'toPrevious'>): Promise<SectionsComparison> {
    const entity = await this.getSectionsComparison.execute(
      new GetSectionsComparisonQuery(params.fromDate, params.toDate, params.organization)
    )

    return this.mapper.map(entity)
  }
}
